import React , { useContext , useState} from "react";
import "../style.css" ;
import Logo from "../assets/Int2criuses_logo.svg" ;
import CurrencySelector from "./CurrencySelector";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes  } from '@fortawesome/free-solid-svg-icons';
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { CurrencyContext } from "./CurrencyContext";



const Navbar = () => {


   const [showModal, setShowModal] = useState(false);

  const currency = useContext(CurrencyContext);

   const phoneNumbers = {
    USD: '+91 920 503 0318',
    INR: '+91 920 503 0318',
    SGD: '+65 8123 7473'
  };

  const navlink ={
    USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&transportid=28&sortcolumn=price&sortorder=asc",
    INR : "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&transportid=28&sortcolumn=price&sortorder=asc",
    SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&transportid=28&sortcolumn=price&sortorder=asc"
  }

    return(
        <>

        <div className="navbar-phone-container">

         <div className="Navbar-Contact2">CALL US : &nbsp;&nbsp; 
            <FontAwesomeIcon icon={faPhone} style={{fontSize:'1.3rem'}}/>
         <h3><a href={`tel:${phoneNumbers[currency.currencyCode]}`} style={{ textDecoration: "none" , color:"#164d55"}}>{phoneNumbers[currency.currencyCode]}</a></h3>
        </div>

        
        <div className="navbar">

           {/* Mobile Button */}
      <div className="mobile-menu-links">
        <button onClick={() => setShowModal(true)} className="menu-button">
          <FontAwesomeIcon icon={faBars} style={{color:"white" , fontSize:'1.4rem'}} />
        </button>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button onClick={() => setShowModal(false)} className="close-button">
              <FontAwesomeIcon icon={faTimes}  style={{color:"white"}}/>
            </button>
    
            <ul className="modal-nav">
              <li><Link to="/" onClick={() => setShowModal(false)}>Home</Link></li>
              <li><Link to="/cruisedeals" onClick={() => setShowModal(false)}>Cruise Deals</Link></li>
  <li><a href={navlink[currency.currencyCode]} className={({ isActive }) => isActive ? "active" : ""}>Land + Cruises</a></li>

              <li><Link to="/contact" onClick={() => setShowModal(false)}>Contact Us</Link></li>
              <li><Link to="/about" onClick={() => setShowModal(false)}>About Us</Link></li>
              <li><Link to="/singapore-cruise" onClick={() => setShowModal(false)} className="scruise-navbar">Cruise from Singapore</Link></li>
            </ul>
          </div>
        </div>
      )}

        <div className="logo-container"> 
            <Link to="/" ><img src={Logo} alt="Int2cruises Logo" className= "  " /></Link>
        </div>

        <div className="pages laptop-responsive">
           <ul>
  <li><NavLink to="/" className={({ isActive }) => isActive ? "active" : ""}>Home</NavLink></li>
  <li><NavLink to="/cruisedeals" className={({ isActive }) => isActive ? "active" : ""}>Cruise Deals</NavLink></li>
  {/* <li><NavLink to="/land+cruise" className={({ isActive }) => isActive ? "active" : ""}>Land + Cruises</NavLink></li> */}
  <li><a href={navlink[currency.currencyCode]} className={({ isActive }) => isActive ? "active" : ""}>Land + Cruises</a></li>
  <li><NavLink to="/contact" className={({ isActive }) => isActive ? "active" : ""}>Contact Us</NavLink></li>
  <li><NavLink to="/about" className={({ isActive }) => isActive ? "active" : ""}>About Us</NavLink></li>
  <li><NavLink to="/singapore-cruise" className="scruise-navbar">Cruise from Singapore</NavLink></li>
</ul>
     </div>

        <div className="Navbar-Contact">
            <FontAwesomeIcon icon={faPhone} style={{fontSize:'1.3rem'}}/>
         <h3><a href={`tel:${phoneNumbers[currency.currencyCode]}`} style={{ textDecoration: "none" , color:"#164d55"}}>{phoneNumbers[currency.currencyCode]}</a></h3>
        </div>
        
        

        <div className="currency-drpdown" ></div>
        {/* <select id="drpCurrency" onchange="handleCurrencyChange()">
       
        <option value="1227501" >SGD</option>
        <option value="1228312" >USD</option>
        <option value="1237318" >INR</option>
        
        </select> */}
        <CurrencySelector/>

        </div>

        </div>

        </>
    )
}

export default Navbar ;